<customer-portal-app-navbar></customer-portal-app-navbar>
<customer-portal-app-navbar-second></customer-portal-app-navbar-second>
<customer-portal-app-revolution-upcoming-appointments
  [upcomingAppointments]="upcomingAppointments"
  [loading]="loading"
>
</customer-portal-app-revolution-upcoming-appointments>
<customer-portal-footer-container></customer-portal-footer-container>
